// extracted by mini-css-extract-plugin
export default {"danger":"#e30000","warning":"#ffc10a","success":"#24c25f","info":"#00c3e6","cardHoverBorder":"#b2d897"};